import script from "./WPasswordRecovery.vue?vue&type=script&setup=true&lang=ts"
export * from "./WPasswordRecovery.vue?vue&type=script&setup=true&lang=ts"

import "./WPasswordRecovery.vue?vue&type=style&index=0&id=e78affca&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e78affca"]])

export default __exports__